// extracted by mini-css-extract-plugin
export default {"container":"AppContainer_container__RrCI7"};